module.exports = __webpack_public_path__ + "img/avatar-1.d1139ee4.png";